import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../components/ui/card';
import { Settings, Users, Zap } from 'lucide-react';
import { Link } from 'react-router-dom';

const Dashboard = () => {
  const { user } = useAuth();

  if (!user) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-red-600 mb-4">Access Denied</h1>
          <p className="text-gray-600">Please log in to access the dashboard.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32 flex-1">
          {/* Header */}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-foreground mb-6 bg-gradient-to-r from-foreground to-foreground/70 bg-clip-text">
              Manage & Control
              <br />
              <span className="bg-gradient-to-r from-primary to-green-600 bg-clip-text text-transparent">
                Every Tool
              </span>
            </h1>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
              Access all your LLM validation tools, team management, and
              organization settings from your central dashboard
            </p>
          </div>

          <div className="space-y-8">
            <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
              {/* LLM Generations */}
              <Link to="/website-checks">
                <Card className="border border-border shadow-sm hover:shadow-md transition-shadow cursor-pointer">
                  <CardHeader>
                    <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                      <Zap className="w-6 h-6 text-blue-600" />
                    </div>
                    <CardTitle className="text-xl">Website Checks</CardTitle>
                    <CardDescription>Comprehensive website analysis and checks</CardDescription>
                  </CardHeader>
                </Card>
              </Link>

              {/* Organization */}
              <Link to="/organization-settings">
                <Card className="border border-border shadow-sm hover:shadow-md transition-shadow cursor-pointer">
                  <CardHeader>
                    <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                      <Settings className="w-6 h-6 text-purple-600" />
                    </div>
                    <CardTitle className="text-xl">Organization</CardTitle>
                    <CardDescription>
                      Manage organization settings
                    </CardDescription>
                  </CardHeader>
                </Card>
              </Link>

              {/* Team Invitations */}
              <Link to="/team-invitations">
                <Card className="border border-border shadow-sm hover:shadow-md transition-shadow cursor-pointer">
                  <CardHeader>
                    <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                      <Users className="w-6 h-6 text-green-600" />
                    </div>
                    <CardTitle className="text-xl">Team Invitations</CardTitle>
                    <CardDescription>
                      Invite and manage team members
                    </CardDescription>
                  </CardHeader>
                </Card>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
